import { Trans, useLingui } from "@lingui/react/macro";
import { X } from "lucide-react";

import { Button } from "@/shared/ui/button";

import { useHeroLookup } from "../../api/useHeroLookup";
import { HeroAvatar } from "../HeroAvatar";

type SelectedHeroesProps = {
  selected: readonly number[];
  onChange: (heroes: number[]) => void;
};

// Выбранные герои под фильтрами: каждого можно убрать, всех — сбросить.
export const SelectedHeroes = ({ selected, onChange }: SelectedHeroesProps) => {
  const { t } = useLingui();
  const lookup = useHeroLookup();
  return (
    <div
      role="group"
      aria-label={t`Selected heroes`}
      className="flex flex-wrap items-center gap-1.5"
    >
      {selected.map(lookup).map(({ id, name, iconUrl }) => (
        <span
          key={id}
          className="inline-flex items-center gap-1.5 rounded-lg border border-border-strong bg-surface-raised py-[3px] pr-1 pl-[3px] text-[13px]"
        >
          <HeroAvatar name={name} iconUrl={iconUrl} size={24} className="rounded-md text-xs" />
          {name}
          <Button
            variant="ghost"
            size="icon"
            className="size-6 text-muted"
            aria-label={t`Remove ${name}`}
            onClick={() => {
              onChange(selected.filter((heroId) => heroId !== id));
            }}
          >
            <X aria-hidden="true" />
          </Button>
        </span>
      ))}
      <Button
        variant="link"
        size="sm"
        onClick={() => {
          onChange([]);
        }}
      >
        <Trans>Clear heroes</Trans>
      </Button>
    </div>
  );
};
